import { ChevronLeft, ChevronRight, Filter, Search } from "lucide-react";
import type { FormEvent, ReactNode, SelectHTMLAttributes } from "react";
import { CustomSelect } from "./CustomSelect";
import { IconButton } from "./IconButton";

export function SearchForm({
  value,
  onChange,
  onSubmit,
  placeholder,
  label = "Buscar",
  buttonLabel = "Buscar",
  className = "",
}: {
  value: string;
  onChange: (value: string) => void;
  onSubmit: () => void;
  placeholder: string;
  label?: string;
  buttonLabel?: string;
  className?: string;
}) {
  function submit(event: FormEvent) {
    event.preventDefault();
    onSubmit();
  }

  return (
    <form
      className={`search-box ${className}`.trim()}
      onSubmit={submit}
      role="search"
    >
      <Search size={18} aria-hidden="true" />
      <input
        type="search"
        aria-label={label}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        placeholder={placeholder}
      />
      <button type="submit">{buttonLabel}</button>
    </form>
  );
}

export function FilterSelect({
  label,
  children,
  className = "",
  ...props
}: SelectHTMLAttributes<HTMLSelectElement> & {
  label: string;
  children: ReactNode;
}) {
  return (
    <div className={`filter-select ${className}`.trim()}>
      <span className="sr-only">{label}</span>
      <CustomSelect label={label} icon={Filter} {...props}>
        {children}
      </CustomSelect>
    </div>
  );
}

export function Pagination({
  page,
  pages,
  onPageChange,
  className = "",
}: {
  page: number;
  pages: number;
  onPageChange: (page: number) => void;
  className?: string;
}) {
  if (pages <= 1) return null;

  return (
    <nav className={`pagination ${className}`.trim()} aria-label="Paginação">
      <span>
        Página {page} de {pages}
      </span>
      <div>
        <IconButton
          label="Página anterior"
          disabled={page <= 1}
          onClick={() => onPageChange(page - 1)}
        >
          <ChevronLeft />
        </IconButton>
        <IconButton
          label="Próxima página"
          disabled={page >= pages}
          onClick={() => onPageChange(page + 1)}
        >
          <ChevronRight />
        </IconButton>
      </div>
    </nav>
  );
}
